import React from 'react';

export default function SerialNumberEnquiry() {
	return (
		<>
			<div className="comp-heading">
				<div className="row">
					<div className="col-lg-4">
						<label>Serial Number Enquiry</label>
					</div>
				</div>
			</div>
			<br />
			serialNumberEnquiry
		</>
	);
}
